export default __webpack_public_path__ + "./fonts/estadosMensuales.4d2150aa.svg";